import { h, Component } from "preact";
import { route } from 'preact-router';
import linkState from 'linkstate';

import { getApiPath } from "../../../path";

class AdminLogin extends Component {
  state = {
    formData: {
      username: "",
      password: ""
    }
  };

  constructor(props) {
    super(props);

    sessionStorage.removeItem("vumc-jwt");
    sessionStorage.removeItem("vumc-profile");
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let fetchPath = getApiPath(this.props.lang, 'user/login');
    fetch(fetchPath, {
      method: 'post',
      body: JSON.stringify(this.state.formData)
    })
      .then(res => res.json())
      .then(result => {
        if (result.status == 200) {
          sessionStorage.setItem("vumc-jwt", result.data);
          this.getProfile();
        } else {
          sessionStorage.removeItem("vumc-jwt");
          sessionStorage.removeItem("vumc-profile");
        }
      });
  }

  getProfile = () => {
    let fetchPath = getApiPath(this.props.lang, 'user/myProfile');
    fetch(fetchPath, {
      method: 'get',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      }
    })
      .then(res => res.json())
      .then(result => {
        if (result.status == 200) {
          sessionStorage.setItem("vumc-profile", JSON.stringify(result.data));
          route("/"+ this.props.lang + "/admin/roman/literature");
        } else {
          sessionStorage.removeItem("vumc-jwt");
          sessionStorage.removeItem("vumc-profile");
        }
      });
  }

  render() {
    return (
      <div class="admin-page">
        <div>
          <h2>Log in</h2>
          <article>
            <form class="admin-form" onSubmit={this.handleSubmit}>
              <div class="form-group">
                <label for="username">Username</label>
                <input type="text" name="username" id="username" value={this.state.formData.username} onInput={linkState(this, 'formData.username')} />
              </div>
              <div class="form-group">
                <label for="password">Wachtwoord</label>
                <input type="password" name="password" id="password" value={this.state.formData.password} onInput={linkState(this, 'formData.password')} />
              </div>

              <div class="form-group">
                <button>Login</button>
              </div>
            </form>
          </article>
        </div>
      </div>
    );
  }
}

export default AdminLogin;
